import { TReduxActions } from '../../../types/redux';
import { EStepActionTypes } from '../../../actions/newReview';
import { ENewReviewModalStep } from '../../../types/newReview';

export const defaultValue = ENewReviewModalStep.Rating;

export function stepReducer(
  state: ENewReviewModalStep = defaultValue,
  { type, payload }: TReduxActions,
): ENewReviewModalStep {
  if (type === EStepActionTypes.Set) {
    return payload;
  }

  return state;
}
